<template>
  <section :style="leftDecoration">
    <div :style="rightDecoration">
      <bl-flex-container-mv style="padding-bottom: 60px;">
        <bl-flex-item-av style="margin-right: 48px;">
          <new-webp-image-container
            src="illustrations/img_medium_rating_desktop.png"
            alt="rating"
            :is-ssr="isSSR"
            styles="width: 369px; height: 326px;"
          />
        </bl-flex-item-av>

        <bl-flex-item-av :grow="1" :shrink="1" style="padding-right: 24px;">
          <bl-text-av tag="h2" variation="heading-42" weigth="bold" style="margin-bottom: 100px;">
            {{ $options.testimonyList.title }}
          </bl-text-av>

          <div v-if="mutualFundTestimonies">
            <bl-flex-container-mv :gutter="16">
              <bl-flex-item-av v-for="(testimony, index) in mutualFundTestimonies" :key="index">
                <article>
                  <bl-card-mv
                    style="position: relative; max-width: 300px; min-height: 140px;padding: 36px 12px 12px"
                    is-outlined
                  >
                    <bl-avatar-av
                      :size="56"
                      style="position: absolute; top: 0px; left: 50%; transform: translate(-50%, -50%); background: #fff; border: 1px solid #EBEBEB"
                      :src="testimony.image_url"
                      alt="avatar"
                    />
                    <bl-text-av class="mb-12" variation="caption-12" align="center">
                      <q>
                        {{ testimony.content }}
                      </q>
                    </bl-text-av>
                    <bl-text-av variation="caption-12" weight="bold" align="center">
                      {{ testimony.name }}
                    </bl-text-av>
                  </bl-card-mv>
                </article>
              </bl-flex-item-av>
            </bl-flex-container-mv>
          </div>
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';
import { TestimonyList as testimonyList } from 'shared/modules/seo/Homepage';
import BlCardMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlCardMv';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexItemAv';
import BlAvatarAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlAvatarAv';

export default {
  name: 'TestimonyList',

  testimonyList,

  components: {
    BlTextAv,
    NewWebpImageContainer,
    BlCardMv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlAvatarAv,
  },

  data() {
    return {
      activeIndicator: 1,
    };
  },

  computed: {
    mutualFundTestimonies() {
      return this.$store.state.server.mutualFundTestimonies;
    },

    isSSR() {
      return this.$root.isSSR;
    },

    leftDecoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'left top',
        'background-image': `url(${assetURL('testimony_list_decoration_desktop_1.png', this.isSSR)})`,
        'background-size': 'contain',
        'padding-top': '60px',
      };
    },

    rightDecoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'bottom right',
        'background-image': `url(${assetURL('testimony_list_decoration_desktop_2.png', this.isSSR)})`,
        'background-size': '100% 80%',
      };
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundTestimonies) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundTestimonies');
    }
  },

  methods: {
    onItemChange(index) {
      this.activeIndicator = index;
    },
  },
};
</script>
